import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { IoClose } from "react-icons/io5";
import {
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { ToastContainer } from "react-toastify";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesServiceRequest = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
};

const initialValuesPublishWithUs = {
  firstName: "",
  qualification: "",
  email: "",
  mobileNumber: "",
  topicOfArticle: "",
  docArticle: "",
};

const initialValuesPartnerWithUs = {
  firstName: "",
  email: "",
  contactNumber: "",
  message: "",
};

const initialValuesAdvertiseWithUs = {
  fullName: "",
  email: "",
  contactNumber: "",
  city: "",
  message: "",
};

const initialValuesSubscribe = {
  firstName: "",
  lastName: "",
  email: "",
};

// Fromik Validation Schema
const schemaServiceRequest = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First Name Is Required")
    .matches(onlyAlphabet, "First Name Is Not Valid"),
  lastName: Yup.string()
    .trim()
    .required("Last Name Is Required")
    .matches(onlyAlphabet, "Last Name Is Not Valid"),
  email: Yup.string()
    .trim()
    .required("Email Is Required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
});

const schemaPublishWithUs = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First Name Is Required")
    .matches(onlyAlphabet, "First Name Is Not Valid"),
  qualification: Yup.string().trim().required("Qualification Is Required"),
  email: Yup.string()
    .trim()
    .required("Email Is Required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile Number Is Required")
    .matches(onlyIntRegExp, "Mobile Number Is Not Valid")
    .min(10, "Mobile Number Is Not Valid")
    .max(16, "Mobile Number Is Not Valid"),
  topicOfArticle: Yup.string().trim().required("Topic Of Article Is Required"),
  docArticle: Yup.string().trim().required("Attach Article"),
});

const schemaPartnerWithUs = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First Name Is Required")
    .matches(onlyAlphabet, "First Name Is Not Valid"),
  email: Yup.string()
    .trim()
    .required("Email Is Required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
  contactNumber: Yup.string()
    .trim()
    .required("Contact Number Is Required")
    .matches(onlyIntRegExp, "Contact Number Is Not Valid")
    .min(10, "Contact Number Is Not Valid")
    .max(16, "Contact Number Is Not Valid"),
  message: Yup.string().trim(),
});

const schemaAdvertiseWithUs = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Full Name Is Required")
    .matches(onlyAlphabet, "Full Name Is Not Valid"),
  email: Yup.string()
    .trim()
    .required("Email Is Required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
  contactNumber: Yup.string()
    .trim()
    .required("Contact Number Is Required")
    .matches(onlyIntRegExp, "Contact Number Is Not Valid")
    .min(10, "Contact Number Is Not Valid")
    .max(16, "Contact Number Is Not Valid"),
  city: Yup.string().trim().required("City Is Required"),
  message: Yup.string().trim(),
});

const schemaSubscribe = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First Name Is Required")
    .matches(onlyAlphabet, "First Name Is Not Valid"),
  lastName: Yup.string()
    .trim()
    .required("Last Name Is Required")
    .matches(onlyAlphabet, "Last Name Is Not Valid"),
  email: Yup.string()
    .trim()
    .required("Email Is Required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
});

const Support = () => {
  const [isServiceRequestModalOpen, setIsServiceRequestModalOpen] =
    useState(false);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const [isPublishWithUsModalOpen, setIsPublishWithUsModalOpen] =
    useState(false);
  const [isPartnerWithUsModalOpen, setIsPartnerWithUsModalOpen] =
    useState(false);
  const [isAdvertiseWithUsModalOpen, setIsAdvertiseWithUsModalOpen] =
    useState(false);
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Service Request Api Call
  const formikServiceRequest = useFormik({
    initialValues: initialValuesServiceRequest,
    validationSchema: schemaServiceRequest,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "servicerequest/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Service Request");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Publish With Us Api Call
  const formikPublishWithUs = useFormik({
    initialValues: initialValuesPublishWithUs,
    validationSchema: schemaPublishWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = new FormData();

      param.append("firstName", values.firstName);
      param.append("qualification", values.qualification);
      param.append("email", values.email);
      param.append("mobileNumber", values.mobileNumber);
      param.append("topicOfArticle", values.topicOfArticle);
      param.append("article", values.docArticle);

      const response = await postData(
        "publishwithus/save",
        param,
        apiHeader(true)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Publish With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Partner With Us Api Call
  const formikPartnerWithUs = useFormik({
    initialValues: initialValuesPartnerWithUs,
    validationSchema: schemaPartnerWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        email: values.email,
        mobileNumber: values.contactNumber,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "partnerwithus/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Partner With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Advertise with us Api Call
  const formikAdvertiseWithUs = useFormik({
    initialValues: initialValuesAdvertiseWithUs,
    validationSchema: schemaAdvertiseWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        fullName: values.fullName,
        email: values.email,
        mobileNumber: values.contactNumber,
        city: values.city,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "advertisewithus/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Advertise With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Subscribe Api Call
  const formikSubscribe = useFormik({
    initialValues: initialValuesSubscribe,
    validationSchema: schemaSubscribe,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
      };

      console.log(param);

      const response = await postData(
        "newsletter/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Subscribe");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Opem Modal Popup Form Function
  const openModal = (type) => {
    document.body.style.overflowY = "hidden";
    if (type == "Service Request") {
      setIsServiceRequestModalOpen(true);
    } else if (type == "Contact Us") {
      setIsContactUsModalOpen(true);
    } else if (type == "Publish With Us") {
      setIsPublishWithUsModalOpen(true);
    } else if (type == "Partner With Us") {
      setIsPartnerWithUsModalOpen(true);
    } else if (type == "Advertise With Us") {
      setIsAdvertiseWithUsModalOpen(true);
    } else if (type == "Subscribe") {
      setIsSubscribeModalOpen(true);
    }
  };

  // Close Modal Popup Form Function
  const closeModal = (type) => {
    document.body.style.overflowY = "";
    if (type == "Service Request") {
      setIsServiceRequestModalOpen(false);
      formikServiceRequest.resetForm();
    } else if (type == "Contact Us") {
      setIsContactUsModalOpen(false);
    } else if (type == "Publish With Us") {
      setIsPublishWithUsModalOpen(false);
      formikPublishWithUs.resetForm();
    } else if (type == "Partner With Us") {
      setIsPartnerWithUsModalOpen(false);
      formikPartnerWithUs.resetForm();
    } else if (type == "Advertise With Us") {
      setIsAdvertiseWithUsModalOpen(false);
      formikAdvertiseWithUs.resetForm();
    } else if (type == "Subscribe") {
      setIsSubscribeModalOpen(false);
      formikSubscribe.resetForm();
    }
  };

  return (
    <>
      <ToastContainer />
      {isServiceRequestModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Service Request")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[1%] flex items-center justify-between">
                <h1 className="hanson">Service Request</h1>
                <IoClose
                  onClick={() => closeModal("Service Request")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <p className="lg:w-[70%] mb-[3%] form-para">
                Welcome to the GCC Law Help! We are here at your service and our
                team is working diligently to resolve your queries. To work on
                your request, we would need few details from your end.
              </p>
              <div className="">
                <form onSubmit={formikServiceRequest.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter First Name"
                        name="firstName"
                        id="firstName"
                        value={formikServiceRequest.values.firstName}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.firstName &&
                        formikServiceRequest.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Last Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Last Name"
                        name="lastName"
                        id="lastName"
                        value={formikServiceRequest.values.lastName}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.lastName &&
                        formikServiceRequest.errors.lastName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.lastName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email Id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email Id"
                        id="email"
                        value={formikServiceRequest.values.email}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.email &&
                        formikServiceRequest.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter Message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikServiceRequest.values.message}
                        onChange={formikServiceRequest.handleChange}
                        rows={3}
                      />
                      {formikServiceRequest.touched.message &&
                        formikServiceRequest.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isContactUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Contact Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Contact Us</h1>
                <IoClose
                  onClick={() => closeModal("Contact Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <div className="mb-[3rem]">
                  <h1 className="mb-[2rem] form-title2-b">
                    You Can Reach Us :
                  </h1>
                  <ul className="pl-[3rem] form-ul-disc-g">
                    <li className="form-ul-disc-g-li">
                      For any queries or service requests.
                    </li>
                    <li className="form-ul-disc-g-li">
                      To know more about our products and services.
                    </li>
                  </ul>
                </div>
                <div>
                  <h1 className="mb-[2rem] form-title2-b">
                    You can contact us through the following ways:
                  </h1>
                  <div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-phone.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          To reach by phone, please call
                        </h1>
                        <h2 className="form-title-y">12345 67890</h2>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-whatsapp.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          To connect via WhatsApp, click the icon below
                        </h1>
                        <h2 className="form-title-y">WhatsApp Me:</h2>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-mail.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          For Email communication
                        </h1>
                        <h2 className="form-title-y">gcclawhelp@gmail.com</h2>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-help.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">To submit e-Form</h1>
                        <h2 className="form-title-y">Click Here</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {isPublishWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Publish With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[25%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Publish With Us</h1>
                <IoClose
                  onClick={() => closeModal("Publish With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikPublishWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter First Name"
                        name="firstName"
                        id="firstName"
                        value={formikPublishWithUs.values.firstName}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.firstName &&
                        formikPublishWithUs.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Qualification
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Qualification*"
                        name="qualification"
                        id="qualification"
                        value={formikPublishWithUs.values.qualification}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.qualification &&
                        formikPublishWithUs.errors.qualification && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.qualification}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile Number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Mobile Number"
                        id="mobileNumber"
                        value={formikPublishWithUs.values.mobileNumber}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.mobileNumber &&
                        formikPublishWithUs.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.mobileNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email Address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email Address"
                        id="email"
                        value={formikPublishWithUs.values.email}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.email &&
                        formikPublishWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Topic Of Article
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Topic Of Article"
                        name="topicOfArticle"
                        id="topicOfArticle"
                        value={formikPublishWithUs.values.topicOfArticle}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.topicOfArticle &&
                        formikPublishWithUs.errors.topicOfArticle && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.topicOfArticle}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Attach Article
                      </label>
                      <label
                        htmlFor="docArticle"
                        className={`flex justify-center gap-2 items-center cursor-pointer form-doc-label form-input ${
                          formikPublishWithUs.values.docArticle == ""
                            ? ""
                            : "form-doc-label-active"
                        }`}
                      >
                        <img
                          src={
                            formikPublishWithUs.values.docArticle == ""
                              ? toAbsoluteUrl(
                                  "media/img/icon/basic/upload-g.svg"
                                )
                              : toAbsoluteUrl(
                                  "media/img/icon/basic/upload-y.svg"
                                )
                          }
                          alt=""
                        />
                        <span className="">Choose File</span>
                      </label>
                      <input
                        className="w-full hidden form-input"
                        type="file"
                        placeholder="Enter Topic Of Article"
                        name="docArticle"
                        id="docArticle"
                        // value={formikPublishWithUs.values.docArticle}
                        onChange={(e) =>
                          formikPublishWithUs.setFieldValue(
                            "docArticle",
                            e.target.files[0] || ""
                          )
                        }
                      />
                      {formikPublishWithUs.touched.docArticle &&
                        formikPublishWithUs.errors.docArticle && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.docArticle}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isPartnerWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Partner With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Partner With Us</h1>
                <IoClose
                  onClick={() => closeModal("Partner With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikPartnerWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter First Name"
                        name="firstName"
                        id="firstName"
                        value={formikPartnerWithUs.values.firstName}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.firstName &&
                        formikPartnerWithUs.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email Id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email Id"
                        id="email"
                        value={formikPartnerWithUs.values.email}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.email &&
                        formikPartnerWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact Number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Contact Number"
                        name="contactNumber"
                        id="contactNumber"
                        value={formikPartnerWithUs.values.contactNumber}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.contactNumber &&
                        formikPartnerWithUs.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter Message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikPartnerWithUs.values.message}
                        onChange={formikPartnerWithUs.handleChange}
                        rows={5}
                      />
                      {formikPartnerWithUs.touched.message &&
                        formikPartnerWithUs.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isAdvertiseWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Advertise With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Advertise With Us</h1>
                <IoClose
                  onClick={() => closeModal("Advertise With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikAdvertiseWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Full Name"
                        name="fullName"
                        id="fullName"
                        value={formikAdvertiseWithUs.values.fullName}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.fullName &&
                        formikAdvertiseWithUs.errors.fullName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.fullName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email Address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email Address"
                        id="email"
                        value={formikAdvertiseWithUs.values.email}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.email &&
                        formikAdvertiseWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact Number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Contact Number"
                        name="contactNumber"
                        id="contactNumber"
                        value={formikAdvertiseWithUs.values.contactNumber}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.contactNumber &&
                        formikAdvertiseWithUs.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        City
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter City"
                        name="city"
                        id="city"
                        value={formikAdvertiseWithUs.values.city}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.city &&
                        formikAdvertiseWithUs.errors.city && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.city}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter Message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikAdvertiseWithUs.values.message}
                        onChange={formikAdvertiseWithUs.handleChange}
                        rows={5}
                      />
                      {formikAdvertiseWithUs.touched.message &&
                        formikAdvertiseWithUs.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isSubscribeModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Subscribe")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] lg:my-0 relative lg:top-[10%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[1%] flex items-center justify-between">
                <h1 className="hanson">Subscribe to Our Newsletter</h1>
                <IoClose
                  onClick={() => closeModal("Subscribe")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <p className="mb-[3%] form-para">
                Stay updated with the latest news, exclusive offers, and special
                updates in your inbox.
              </p>
              <div className="">
                <form onSubmit={formikSubscribe.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-3 gap-[2rem] gap-y-[1rem] mb-[5rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter First Name"
                        name="firstName"
                        id="firstName"
                        value={formikSubscribe.values.firstName}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.firstName &&
                        formikSubscribe.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Last Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Last Name"
                        name="lastName"
                        id="lastName"
                        value={formikSubscribe.values.lastName}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.lastName &&
                        formikSubscribe.errors.lastName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.lastName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email Address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email Address"
                        id="email"
                        value={formikSubscribe.values.email}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.email &&
                        formikSubscribe.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rem] form-title2-b">Why Subscribe?</h1>
                    <ul className="pl-[3rem] lg:pl-[5rem] form-ul-disc-g">
                      <li className="form-ul-disc-g-li">
                        Exclusive Content - Get access to content that is not
                        available anywhere else.
                      </li>
                      <li className="form-ul-disc-g-li">
                        Special Offers - Be the first to know about our special
                        promotions and discounts.
                      </li>
                      <li className="form-ul-disc-g-li">
                        Latest Update - Stay informed about the latest news and
                        updates.
                      </li>
                    </ul>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rem] form-title2-b">Privacy Policy</h1>
                    <p className="form-para">
                      We respect your privacy. Your information is safe and will
                      never be shared.
                    </p>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rerm] form-title2-b">
                      Unsubscribe Anytime
                    </h1>
                    <p className="form-para">
                      You can unsubscribe anytime by clicking the link in the
                      footer of our emails.
                    </p>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Subscribe Now</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full h-max relative footer">
        <div className="w-[90%] relative z-[1] py-[3%] mx-auto flex flex-col gap-[10%] justify-center text-white footer-menu">
          <Link className="mb-[2rem] text-center">Contact Us</Link>
          <div className="w-full mb-[2rem] flex flex-wrap justify-center">
            <h1 className="w-full mb-[1rem] lg:mb-0 lg:w-[15%] text-center lg:text-end">
              Legal :
            </h1>
            <Link
              to={"/privacypolicy"}
              className="footer-submenu"
            >
              Privacy Policy
            </Link>
            <Link
              to={"/enduserlicenseagreement"}
              className="footer-submenu"
            >
              End User Agreement
            </Link>
            <Link
              to={"/disclaimerandcopyrights"}
              className="footer-submenu"
            >
              Disclaimer & Copyrights
            </Link>
            <Link
              to={"/paymentterms"}
              className="footer-submenu"
            >
              Payment Terms
            </Link>
            <Link
              to={"/cancellationreturnrefundpolicy"}
              className="footer-submenu"
            >
              Cancellation Policy
            </Link>
            <Link
              to={"/aboutus"}
              className="footer-submenu"
            >
              About Us
            </Link>
          </div>
          <div className="w-full flex flex-wrap justify-center">
            <h1 className="w-full mb-[1rem] lg:mb-0 lg:w-[15%] text-center lg:text-end">
              Support :
            </h1>
            <button
              onClick={() => openModal("Service Request")}
              className="footer-submenu"
            >
              Service Request
            </button>
            <button
              onClick={() => openModal("Contact Us")}
              className="footer-submenu"
            >
              Contact Us
            </button>
            <Link to={"/location"} className="footer-submenu">
              Location
            </Link>
            <button
              onClick={() => openModal("Publish With Us")}
              className="footer-submenu"
            >
              Publish With Us
            </button>
            <button
              onClick={() => openModal("Partner With Us")}
              className="footer-submenu"
            >
              {" "}
              Partner With Us
            </button>
            <button
              onClick={() => openModal("Advertise With Us")}
              className="footer-submenu"
            >
              Advertise With Us
            </button>
            <button
              onClick={() => openModal("Subscribe")}
              className="footer-submenu"
            >
              Subscription
            </button>
          </div>
        </div>
        <div className="w-[90%] relative z-[1] mx-auto pt-[5%] md:pt-[2%] pb-[5%] sm:pb-[2%] gap-10 items-center lg:gap-0 flex flex-col lg:flex-row">
          <div className="w-full text-center lg:text-start">
            <p className="copyright text-center">
              Copyright ©{" "}
              <span>
                <Link to={"/"}>GCC Law Help</Link>
              </span>{" "}
              | Designed & Development by{" "}
              <span>
                <a href="https://xpertlab.com/" target="_blank">
                  XpertLab Technologies Private Limited
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
